import { render, staticRenderFns } from "./gtr-card.vue?vue&type=template&id=3d6d7b19"
import script from "./gtr-card.ts?vue&type=script&lang=ts&external"
export * from "./gtr-card.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports